import { fetchClient } from "checkout-query-client/api/fetch-client";
import { PayRequestPayload } from "checkout-query-client/api/types";
import { PaymentType } from "checkout-query-client/types/form-types";
import { buildApplePayload } from "checkout-query-client/utils/build-payloads/build-apple-payload";
import { buildCreditCardPayload } from "checkout-query-client/utils/build-payloads/build-credit-card-payload";
import { buildECPayload } from "checkout-query-client/utils/build-payloads/build-ecp-payload";
import { buildGiftCardPayload } from "checkout-query-client/utils/build-payloads/build-gift-card-payload";
import { buildGooglePayload } from "checkout-query-client/utils/build-payloads/build-google-payload";
import { buildLpmPayload } from "checkout-query-client/utils/build-payloads/build-lpm-payload";
import { buildPayByBankPayload } from "checkout-query-client/utils/build-payloads/build-pay-by-bank-payload";
import { buildPazePayload } from "checkout-query-client/utils/build-payloads/build-paze-payload";
import { buildSavedPaymentPayload } from "checkout-query-client/utils/build-payloads/build-saved-payment-payload";
import { buildSepaPayload } from "checkout-query-client/utils/build-payloads/build-sepa-payload";

import { PayRequest, PayResponse, PayResponse_Status } from "frontend-client";

export const buildRequestBySubmitType = async (
  payload: PayRequestPayload
): Promise<PayRequest> => {
  switch (payload.submitType) {
    case PaymentType.creditCard:
      return await buildCreditCardPayload(payload);
    case PaymentType.eCheck:
      return await buildECPayload(payload);
    case PaymentType.applePay:
      return await buildApplePayload(payload);
    case PaymentType.googlePay:
      return await buildGooglePayload(payload);
    case PaymentType.sepa:
      return await buildSepaPayload(payload);
    case PaymentType.paze:
      return await buildPazePayload(payload);
    case PaymentType.payByBank:
      return await buildPayByBankPayload(payload);
    case PaymentType.ideal:
    case PaymentType.alipay:
    case PaymentType.paypal:
    case PaymentType.wechatPay:
    case PaymentType.trustly:
      return await buildLpmPayload(payload);
    case PaymentType.giftCard:
      return await buildGiftCardPayload(payload);
    default:
      return await buildSavedPaymentPayload(payload);
  }
};

export const makePayment = async (
  apiHost: string,
  version: string,
  language: string,
  checkoutSessionToken: string,
  payload: PayRequestPayload
): Promise<PayResponse> => {
  const request = await buildRequestBySubmitType(payload);
  return fetchClient({ apiHost, version })
    .pay(request, {
      headers: {
        Authorization: "Bearer " + checkoutSessionToken,
        locale: language,
      },
    })
    .then((response: PayResponse) => response)
    .catch(() => {
      return new PayResponse({ status: PayResponse_Status.FAILURE });
    });
};
